import { useTranslations } from '@fshr/context/i18n-context';
import { type SearchResultsReturn } from '@micro-apps/env';
import { appendIcmpQueryParam } from '@fshr/shared';
import { SearchModalCard } from './SearchModalCard';

const SearchResults = ({
	searchResults,
	searchIcmpValue,
}: {
	searchResults?: SearchResultsReturn;
	searchIcmpValue?: string;
}) => {
	const t = useTranslations();
	if (!searchResults) {
		return null;
	}
	return (searchResults.numberOfResults || 0) > 0 ? (
		<div className="flex flex-col gap-[30px] pb-400">
			{searchResults.results.properties.length > 0 && (
				<div className="flex flex-col spacing-stack-s">
					<h2 className="text-label text-text-secondary">{t('Property')}</h2>
					{searchResults.results.properties.map((property, index) => {
						return (
							<SearchModalCard
								key={`property-${index}-${property.url}`}
								image={property?.image}
								title={property?.title}
								description={property?.location}
								url={appendIcmpQueryParam(property?.url, searchIcmpValue)}
								variant="search-property"
								showSeparator={index < searchResults.results.properties.length - 1}
							/>
						);
					})}
				</div>
			)}
			<div className="flex flex-col spacing-stack-s">
				{searchResults.results.properties.length > 0 && (
					<h2 className="text-label text-text-secondary">{t('Other')}</h2>
				)}
				{searchResults.results.other.slice(0, 25).map((result, index) => {
					return (
						<SearchModalCard
							key={`other-${index}-${result.url}`}
							title={result?.title}
							description={result?.excerpt}
							url={appendIcmpQueryParam(result?.url, searchIcmpValue)}
							variant="search-other"
							showSeparator={index < searchResults.results.other.length - 1}
						/>
					);
				})}
			</div>
		</div>
	) : (
		<span className="text-subtitle1 text-text-secondary">{t('No results')}</span>
	);
};

export default SearchResults;
